import React, { useState } from 'react';
import MessageDisplay from './MessageDisplay';
import FullMessage from './Updated version/FullMessage';
import "./Updated version/ChatRoom.scss"
const MessageDisplayParent = () => {
  // Replace with your authentication logic to get the current user
  const currentUser = {
    id: 1,
    username: 'Dave', // Replace with the actual user's username
  };

  return (
  
         <FullMessage/>
    
  );
};

export default MessageDisplayParent